import { render } from "./VendorDetailCmp.vue?vue&type=template&id=68b7da98"
import script from "./VendorDetailCmp.vue?vue&type=script&lang=js"
export * from "./VendorDetailCmp.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__